import styled from 'styled-components';

import { black } from '../../modules/colors';
import media from '../../modules/media';
import { fonts, spacing } from '../../modules/metrics';
import Button from '../button/Button';
import CardComponent from '../card/Card';
import Icon from '../icon/Icon';

export const Wrapper = styled.div``;

export const Spacer = styled.div`
  margin-top: 14px;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Row = styled.div`
  display: flex;
`;

export const Card = styled(CardComponent)`
  align-self: flex-end;
  font-size: ${fonts.xs}px;
  line-height: 16px;
  padding: ${spacing.sm}px ${spacing.md}px;
  ${(props) => props.withCheckbox && `padding: 0 ${spacing.md}px 0 0;`}
  ${(props) => props.viewOutside && 'overflow: visible !important;'}
`;

export const InnerCardWrapper = styled.div`
  display: flex;

  > div:last-child {
    overflow: hidden;
  }
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const CardContent = styled.div`
  ${(props) => props.isFlex && 'display: flex; justify-content: space-between;'}
`;

export const BasicInfoWrapper = styled.div`
  display: flex;
  width: 90%;
  margin-top: ${spacing.md}px;

  > div {
    width: 50%;

    :nth-child(1) {
      margin-right: ${spacing.md}px;
    }
  }
`;

export const DescriptionWrapper = styled.div`
  width: 90%;
  margin-top: ${spacing.md}px;
  margin-bottom: ${spacing.sm}px;

  > input {
    width: 100%;
  }
`;

export const Title = styled.div`
  align-self: center;
  display: flex;
  line-height: 20px;
  white-space: nowrap;
  ${(props) => props.withCheckbox && `margin-left: ${spacing.md}px`}
`;

export const EquipmentInfo = styled.span`
  font-style: italic;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 230px;

  ${media.bigDesktop} {
    max-width: 80px;
  }
  ${media.desktop} {
    max-width: 300px;
  }
  ${media.tablet} {
    max-width: 150px;
  }
  ${media.phone} {
    max-width: 60px;
  }
`;

export const InfoText = styled.span``;

export const Box = styled.div`
  width: 28px;
  height: ${(props) => (props.expand ? '60' : '28')}px;
  border-left: 1px solid black;
  border-bottom: 1px solid black;
  margin-left: ${spacing.xs}px;
  ${(props) =>
    props.expand &&
    props.items !== undefined &&
    `height: ${38 + props.items * 16}px`}
`;

export const Box2 = styled.div`
  width: 28px;
  height: ${(props) => (props.expand ? '48' : '14')}px;
  border-left: ${(props) => (props.isLast ? 'none' : '1px solid black')};
  margin-left: ${spacing.xs}px;
  ${(props) =>
    props.expand &&
    props.items !== undefined &&
    `height: ${36 + props.items * 12}px`}
`;

export const Box3 = styled.div`
  width: 28px;
  height: ${(props) => (props.expand ? '60' : '28')}px;
  border-left: ${(props) => (props.isLast ? 'none' : '1px solid black')};
  margin-left: ${spacing.xs}px;
  ${(props) =>
    props.expand &&
    props.items !== undefined &&
    `height: ${38 + props.items * 16}px`}
`;

export const ActionsWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const Action = styled(Button)`
  margin-left: ${spacing.md}px;
`;

export const IconStyled = styled(Icon)`
  margin-right: ${spacing.sm}px;
`;

export const NoSearch = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  > * {
    ${(props) => props.visible && 'display:none;'};
  }
`;

export const SubHeading = styled.div`
  margin: 0;
  font-size: ${fonts.lg}px;
  color: ${black};
  line-height: 34px;
`;

export const Search = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${spacing.lg}px;

  > * {
    ${(props) => !props.visible && 'display:none;'};
  }

  > div {
    align-items: center;
  }
`;

export const SearchHeading = styled(SubHeading)`
  margin-right: ${spacing.md}px;
`;

export const ButtonStyled = styled(Button)`
  margin-left: ${spacing.md}px;
  align-self: center;
`;

export const ServicesWrapper = styled.div`
  width: 50%;
  margin-top: ${spacing.sm}px;
  margin-bottom: ${spacing.sm}px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;

  > div > div > input {
    margin-top: 1px;
  }
`;

export const List = styled.div`
  > * {
    padding: ${spacing.sm}px 0 !important;
  }
`;

export const InputRow = styled.div`
  display: flex;

  > button {
    align-self: center;
  }
`;

export const AttachmentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${spacing.sm}px 0;
  width: 100%;
  font-size: ${fonts.xs}px;
  color: ${black};

  > div :nth-child(1) {
    margin-left: 0;
  }
`;
